import { ValidationUtils } from '@elotech/components';

export const validateCpf = ValidationUtils.validateCpf;
export const validateCnpj = ValidationUtils.validateCnpj;

export const validateCpfCnpj = (cpfCnpj?: string): boolean => {
  if (!cpfCnpj) return false;
  return ValidationUtils.validateCpfCnpj(cpfCnpj);
};
